import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  dialog: {
    [theme.breakpoints.down('sm')]: {
      '& .MuiDialog-container': {
        alignItems: 'flex-end',
        paddingBottom: theme.spacing(6.5),
      },
      '& .MuiPaper-root': {
        margin: 0,
        width: '100%',
        overflowY: 'initial',
      },
      '& .MuiDialogContent-root': {
        paddingInline: theme.spacing(2),
      },
      '& $helperText': {
        marginBottom: theme.spacing(0),
      },
    },
  },
  header: {
    position: 'relative',
    backgroundColor: theme.palette.neutral.lightest,
  },
  closeButton: {
    position: 'absolute',
    top: theme.spacing(2),
    right: theme.spacing(2),
    display: 'block',
    color: 'neutral.main',
    backgroundColor: theme.palette.neutral.lightest,
  },

  helperText: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  downloadLabelButton: {
    margin: theme.spacing(2, 0, 5),
  },
  alertPrint: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(2),
    '& .MuiLink-root': {
      marginTop: theme.spacing(1.5),
      fontFamily: 'ActoMedium',
      fontWeight: 500,
      fontSize: 14,
      '&::after': {
        backgroundColor: theme.palette.primary.main,
      },
    },
  },
  linkButtonWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: theme.spacing(0, 2),
  },
}))

export default useStyles
